import * as React from 'react';
import { useEffect } from 'react';
import TradePage from '../../../common/components/TradePage/TradePage';
import GTPFlowPageSubtitle from '../GTPFlowPageSubtitle/GTPFlowPageSubtitle';
import config from '../../../store/mmd/config';
import { IAutoLoanUnavailableUIProps } from './AutoLoanUnavailableInterfaces';
import { ButtonText } from '../constants';
import { LoadingButtonUI } from '@makemydeal/dr-activities-common';

export const AutoLoanUnavailableUI: React.FC<IAutoLoanUnavailableUIProps> = (props) => {
    const {
        pageTitle,
        pageSubTitle,
        stepperRoutes,
        goToRoute,
        dispatchAnalytics,
        renderDisclaimer,
        vehicleName,
        goBack,
        removeTrade,
        cdlPageView,
        tradeIndex,
        urlPath
    } = props;

    useEffect(() => {
        cdlPageView();
    }, []);

    return (
        <TradePage
            headerOnTop
            showCustomTitle
            pageClass="dr-auto-loan-unavailable-page"
            pageTitle={pageTitle}
            pageSubTitle={<GTPFlowPageSubtitle pageSubtitle={pageSubTitle} suffix={vehicleName} tradeIndex={tradeIndex} />}
            renderDisclaimer={renderDisclaimer}
            goToRoute={goToRoute}
            dispatchAnalytics={dispatchAnalytics}
            urlPath={urlPath}
            footerProps={{
                fullWidthLayout: true,
                showBackButton: true,
                onBackButtonClick: () => goBack(),
                showSkipButton: true,
                skipButtonText: 'Cancel Trade-in',
                onSkipButtonClick: removeTrade
            }}
            stepperRoutes={stepperRoutes}
            showTradeErrorMessage={false}
            staticAssetsConfig={config.staticImages}
            stepLabelVisible={true}
            isStepperClickable={false}
        >
            <section className="dr-auto-loan-unavailable-container">
                <h3 className="dr-auto-loan-unavailable-header">We can't access your open auto loan.</h3>
                <p className="dr-auto-loan-unavailable-subheader">
                    You can also estimate your loan balance. We'll confirm the exact amount before finalizing your purchase.
                </p>
                <div className="btn-ui-wrapper">
                    <LoadingButtonUI
                        buttonText={ButtonText.EstimateLoanBalance}
                        disabled={false}
                        isPending={false}
                        id="action_footer_bar_action_button"
                        dataTestId="dr-auto-loan-unavailable-action-button"
                        isSubmit={true}
                        onClick={props.next}
                        additionalClassParams="auto-loan-unavailable_action_button"
                    />
                </div>
            </section>
        </TradePage>
    );
};

export default AutoLoanUnavailableUI;
